import { Helmet } from "react-helmet-async";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { LoanTimeline } from "@/components/LoanTimeline";

export default function Timeline() {
  const { user, signOut } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Family Loan Timeline™ — Family Loan Planner</title>
        <meta name="description" content="A chronological history of your family financing commitments and payment activity." />
      </Helmet>
      <header className="border-b bg-primary text-primary-foreground">
        <div className="container mx-auto h-16 px-4 flex items-center justify-between">
          <Link to="/" className="font-semibold">Family Loan Planner™</Link>
          <div className="flex items-center gap-3 text-sm">
            <Link to="/scenarios" className="opacity-80 hover:opacity-100">My Scenarios</Link>
            <span className="opacity-80 hidden sm:inline">{user?.email}</span>
            <Button variant="secondary" size="sm" onClick={async () => { await signOut(); nav("/"); }}>
              Sign out
            </Button>
          </div>
        </div>
      </header>
      <main className="container mx-auto px-4 py-8 max-w-5xl">
        {user && <LoanTimeline userId={user.id} />}
      </main>
    </div>
  );
}